import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RappiderClickToDialComponent } from './click-to-dial.component';
import { RappiderButtonModule } from '../button/button.module';
import { RappiderIconModule } from '../icon/icon.module';


@NgModule({
  declarations: [
    RappiderClickToDialComponent
  ],
  imports: [
    CommonModule,
    RappiderButtonModule,
    RappiderIconModule
  ],
  exports: [
    RappiderClickToDialComponent
  ]
})
export class RappiderClickToDialModule { }
